import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import UserRoles from "../../constants/UserRoles";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import Add from "@material-ui/icons/Add";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {confirmAlert} from "react-confirm-alert";

const PHONE_PARSER_OPTIONS = [
	{value: 'generic', label: 'Generic (subject match only)'},
	{value: 'ring', label: 'RingCentral (Voice/Text Message)'},
	{value: 'google_voice', label: 'Google Voice (voicemail)'},
	{value: 'call', label: 'Call (New Call / missed call)'},
	{value: 'appointment_request', label: 'Appointment request (website)'},
];

const emptyForm = () => ({
	pattern: '',
	phone_parser: 'generic',
	active: true,
	sort_order: 0,
});

class FreshdeskMergeSubjects extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Freshdesk_Merge_Subjects._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 25;
		this.state.modalOpen = false;
		this.state.editing = null;
		this.state.form = emptyForm();
	}

	// fetchData = async () => {
	// 	this.setState({loading: true});
	// 	try {
	// 		const model = new API.BuildClass(Types.Freshdesk_Merge_Subjects._name, API.RequestType.READ);
	// 		const response = await model.submit(null, 'GET');
	// 		this.setState({
	// 			data: response?.items ?? [],
	// 			pages: 1,
	// 			loading: false,
	// 		});
	// 	} catch (error) {
	// 		console.error('Failed to load Freshdesk merge subjects', error);
	// 		this.setState({loading: false});
	// 	}
	// }

	openCreateModal = () => {
		this.setState({modalOpen: true, editing: null, form: emptyForm()});
	}

	openEditModal = (row) => {
		this.setState({
			modalOpen: true,
			editing: row,
			form: {
				pattern: row.pattern ?? '',
				phone_parser: row.phone_parser ?? 'generic',
				active: row.active !== false,
				sort_order: row.sort_order ?? 0,
			},
		});
	}

	closeModal = () => {
		this.setState({modalOpen: false, editing: null, form: emptyForm()});
	}

	saveItem = async () => {
		const {editing, form} = this.state;
		const payload = {
			pattern: form.pattern.trim(),
			phone_parser: form.phone_parser,
			active: form.active,
			sort_order: parseInt(form.sort_order, 10) || 0,
		};

		if (!payload.pattern) {
			return;
		}

		try {
			if (editing) {
				const model = new API.BuildClass(Types.Freshdesk_Merge_Subjects._name, API.RequestType.UPDATE);
				model.object = {...payload, pkey: editing.pkey};
				await model.submit(editing.pkey, 'POST');
			} else {
				const model = new API.BuildClass(Types.Freshdesk_Merge_Subjects._name, API.RequestType.CREATE);
				model.object = payload;
				await model.submit(null, 'PUT');
			}
			this.closeModal();
			await this.fetchData();
		} catch (error) {
			console.error('Failed to save Freshdesk merge subject', error);
		}
	}

	deleteItem = (row) => {
		confirmAlert({
			title: 'Delete merge filter',
			message: `Remove "${row.pattern}" from the merge whitelist?`,
			buttons: [
				{
					label: 'Delete',
					onClick: async () => {
						try {
							const model = new API.BuildClass(Types.Freshdesk_Merge_Subjects._name, API.RequestType.DELETE);
							await model.submit(row.pkey, 'DELETE');
							await this.fetchData();
						} catch (error) {
							console.error('Failed to delete Freshdesk merge subject', error);
						}
					},
				},
				{label: 'Cancel', onClick: () => {}},
			],
		});
	}

	canEdit = () => {
		return this.props.rootState?.roles?.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role));
	}

	render() {
		const {data, limit, loading, modalOpen, form, editing} = this.state;
		const editable = this.canEdit();

		const columns = [
			{
				Header: 'Sort',
				id: 'sort_order',
				width: 60,
				accessor: obj => obj.sort_order,
			},
			{
				Header: 'Subject pattern',
				id: 'pattern',
				accessor: obj => obj.pattern,
			},
			{
				Header: 'Phone parser',
				id: 'phone_parser',
				accessor: obj => {
					const match = PHONE_PARSER_OPTIONS.find(o => o.value === obj.phone_parser);
					return match ? match.label : obj.phone_parser;
				},
			},
			{
				Header: 'Active',
				id: 'active',
				accessor: obj => (obj.active ? 'Yes' : 'No'),
			},
		];

		if (editable) {
			columns.push({
				Header: '',
				id: 'actions',
				width: 90,
				sortable: false,
				Cell: props => (
					<span>
						<Button color="green-meadow" size="sm" onClick={() => this.openEditModal(props.original)}>
							<Edit fontSize="small"/>
						</Button>
						{' '}
						<Button color="danger" size="sm" onClick={() => this.deleteItem(props.original)}>
							<Delete fontSize="small"/>
						</Button>
					</span>
				),
			});
		}

		return (
			<Card>
				<CardContent>
					<div className="table-bar mb-3">
						<div className="d-flex justify-content-between align-items-center">
							<div>
								<h5 className="mb-1">Freshdesk merge subject whitelist</h5>
								<p className="text-muted mb-0">
									Incoming Freshdesk tickets whose subject contains one of these patterns are queued for phone-based merge processing.
								</p>
							</div>
							{editable &&
								<Button color="primary" onClick={this.openCreateModal}>
									<Add fontSize="small"/> Add pattern
								</Button>
							}
						</div>
					</div>

					<ReactTable
						key={this.state.key}
						columns={columns}
						manual
						data={data}
						pages={1}
						loading={loading}
						loadingText="Loading merge filters"
						onFetchData={this.fetchData}
						defaultSorted={[{id: 'sort_order', desc: false}]}
						defaultPageSize={limit}
						pageSize={limit}
						onPageSizeChange={this.onPageSizeChange}
						showPagination={(data?.length ?? 0) > limit}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>

					<Modal isOpen={modalOpen} toggle={this.closeModal} size="md">
						<ModalHeader toggle={this.closeModal}>
							{editing ? 'Edit merge filter' : 'Add merge filter'}
						</ModalHeader>
						<ModalBody>
							<div className="form-group">
								<TextField
									fullWidth
									size="small"
									label="Subject pattern (substring match)"
									value={form.pattern}
									variant="outlined"
									onChange={(e) => this.setState({form: {...form, pattern: e.target.value}})}
									helperText="Example: Voice Message, Appointment request"
								/>
							</div>
							<div className="form-group">
								<TextField
									select
									fullWidth
									size="small"
									label="Phone parser"
									value={form.phone_parser}
									variant="outlined"
									onChange={(e) => this.setState({form: {...form, phone_parser: e.target.value}})}
									SelectProps={{native: true}}
								>
									{PHONE_PARSER_OPTIONS.map(option => (
										<option key={option.value} value={option.value}>{option.label}</option>
									))}
								</TextField>
							</div>
							<div className="form-group">
								<TextField
									fullWidth
									size="small"
									label="Sort order"
									type="number"
									value={form.sort_order}
									variant="outlined"
									onChange={(e) => this.setState({form: {...form, sort_order: e.target.value}})}
								/>
							</div>
							<FormControlLabel
								control={
									<Checkbox
										checked={form.active}
										onChange={(e) => this.setState({form: {...form, active: e.target.checked}})}
										color="primary"
									/>
								}
								label="Active"
							/>
						</ModalBody>
						<ModalFooter>
							<Button color="primary" onClick={this.saveItem}>Save</Button>
							<Button color="secondary" onClick={this.closeModal}>Cancel</Button>
						</ModalFooter>
					</Modal>
				</CardContent>
			</Card>
		);
	}
}

export default Framework.Components.withRootState(FreshdeskMergeSubjects);
